import React from "react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import UserPanel from "./UserPanel";
import { useFirebase } from "../FbContex";

const UserDropdown = () => {
  const { user } = useFirebase();

  return (
    <Popover>
      <PopoverButton className="block focus:outline-none">
        <img
          width={52}
          height={52}
          className="rounded-full size-12 border-none shadow-lg"
          src={user?.photoURL as string}
          alt="ava"
        />
      </PopoverButton>
      <PopoverPanel
        transition
        anchor="bottom"
        className="divide-y divide-white/5 rounded-xl dark:bg-gray-700 bg-gray-300 text-sm/6 transition duration-200 ease-in-out [--anchor-gap:var(--spacing-5)] data-[closed]:-translate-y-1 data-[closed]:opacity-0 z-20"
      >
        <UserPanel />
      </PopoverPanel>
    </Popover>
  );
};

export default UserDropdown;
